
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.186 10.186a5.017 5.017 0 117.095 7.095 5.017 5.017 0 01-7.095-7.095zm3.547.03a3.516 3.516 0 100 7.034 3.516 3.516 0 000-7.033z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.733 11.098a.75.75 0 01.75.75v1.135h1.136a.75.75 0 010 1.5h-1.886a.75.75 0 01-.75-.75v-1.886a.75.75 0 01.75-.75zM3.067 2.75a.317.317 0 00-.317.317V11.6a.317.317 0 00.317.317h4.266a.75.75 0 010 1.5H3.067A1.817 1.817 0 011.25 11.6V3.067A1.817 1.817 0 013.067 1.25h12.8a1.816 1.816 0 011.816 1.817v4.8a.75.75 0 01-1.5 0v-4.8a.317.317 0 00-.316-.317h-12.8z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.647 1.934a.75.75 0 011.051-.137L8.49 6.25a1.602 1.602 0 001.954 0l5.79-4.454a.75.75 0 01.915 1.189L11.36 7.44a3.102 3.102 0 01-3.784 0L1.784 2.986a.75.75 0 01-.137-1.052z","clip-rule":"evenodd"}})])
          )
        }
      }
    